const PAGES = [-2, -1, 1, 2]

export const getPages = ({ current, total }) => {
  const numbers = [current]

  PAGES.forEach((item) => {
    let page = current + item
    if (page > total) {
      page = total - item - 2
    }

    if (page < 1) {
      page = 1 + Math.abs(item) + 2
    }

    numbers.push(page)
  })

  return [...new Set(numbers.sort((a, b) => a - b))]
}
